/* eslint-disable import/prefer-default-export */
import { call } from 'redux-saga/effects'
import { functions } from '../../../utilities/firebase'

export function* getFeed() {
	const { data: feed } = yield call(functions.httpsCallable('feed'))
	return { feed }
}



// WEBPACK FOOTER //
// ./src/redux/saga/feed/sagas.js